import { Button, Flex, Form, Modal, Typography } from 'antd';
import { Franchise } from '@/types';
import { useEffect } from 'react';

interface Props {
  open: boolean;
  onCancel: () => void;
  handleFinish: (values: any) => void;
  currentFranchisor?: Partial<Franchise>;
  loading: boolean;
}

export default function DeleteUserModal({
  open,
  onCancel,
  handleFinish,
  loading,
  currentFranchisor,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(currentFranchisor);
  }, [form, currentFranchisor]);

  return (
    <Modal title="Delete User?" open={open} footer={null} centered>
      <div className={'modal-section-line'} style={{ marginBlock: 16 }}>
        <Typography.Text className="general-info-text">
          Are you sure you want to delete this user?
        </Typography.Text>
      </div>
      <Flex gap={12}>
        <Button
          onClick={handleFinish}
          type={'primary'}
          className="admin-button-download-table"
          style={{
            paddingInline: '32px',
            width: '100%',
          }}
          disabled={loading}
        >
          Delete
        </Button>

        <Button
          type={'default'}
          onClick={onCancel}
          style={{
            backgroundColor: 'white',
            color: '#1C8271',
            boxShadow: 'none',
            width: '100%',
            height: '40px',
            paddingInline: '32px',
          }}
        >
          Cancel
        </Button>
      </Flex>
    </Modal>
  );
}
